import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-50">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 pb-2 border-b border-foreground-700/30">
              热门分类
            </h4>
            <ul className="space-y-3">
              {categoryList.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to="/"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 pb-2 border-b border-foreground-700/30">
              快速入口
            </h4>
            <ul className="space-y-3">
              {categoryList.slice(4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to="/"
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-300 hover:text-primary-400 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 pb-2 border-b border-foreground-700/30">
              友情链接
            </h4>
            <ul className="space-y-3">
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  吃瓜爆料网入口
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  吃瓜爆料网51
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  吃瓜官网
                </a>
              </li>
              <li>
                <a href="#" rel="nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  吃瓜爆料网站
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-bold text-background-50 mb-4 pb-2 border-b border-foreground-700/30">
              关于我们
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">
                  免责声明
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 md:mt-16 pt-8 border-t border-foreground-700/30 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <h2 className="text-2xl font-bold text-background-50 font-heading mb-1">
              吃瓜爆料网
            </h2>
            <p className="text-xs text-foreground-400">
              每日速递一手八卦 · 明星塌房 · 网红黑料 · 反差视频
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 吃瓜爆料网 版权所有
            </p>
            <div className="flex items-center gap-3">
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-foreground-300"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-foreground-300"></i>
              </a>
              <a href="#" rel="nofollow" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm text-foreground-300"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}